import { StatePropertyRef } from '../../canvas/ExtendableStore';

export type ConcealmentMode = 'public' | 'private';
export interface ConcealmentInfo {
    enabled: boolean;
    mode: ConcealmentMode;
    mostly?: boolean;
}

export const CreateConcealmentInfo = (enabled: boolean, mode: ConcealmentMode = 'private') =>
    ({ enabled, mode, selected: 'private' }) as ConcealmentInfo;

export const ConcealmentInfo = StatePropertyRef<ConcealmentInfo>('concealment', CreateConcealmentInfo(false));

export const DefaultConcealmentInfo = (() => {
    const d = CreateConcealmentInfo(false);
    return () => d;
})();
